import React, { Ref, forwardRef, useEffect, useState } from "react"
import useMainMenu from "../../hooks/useMainMenu"
import { Wrapper, Content, MenuWrapper, MenuItem, MenuItemWrapper, ContentWrapper } from './header.style'
import { Link } from "gatsby"


type Props = {
  actualSite?: string
}

const Header = forwardRef(({ actualSite }: Props, ref) => {

  const { left, right } = useMainMenu()

  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < 100) {
        setScrollY(0)
      } else if (window.scrollY > 200) {
        setScrollY(window.scrollY)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return function unMount() {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  return (
    <Wrapper >
      <Content>
        <MenuWrapper>
          <ContentWrapper>
            {left.map((menuItem, key) => {
              return <Link key={key} to={menuItem.url} target={menuItem.blank ? "_blank" : ""} >
                <MenuItemWrapper active={actualSite == menuItem.key} scroll={scrollY} key={key} border={menuItem.border}>
                  <MenuItem outlined={menuItem.outlined} >{menuItem.title}</MenuItem>
                </MenuItemWrapper>
              </Link>

            })}
          </ContentWrapper>
          <ContentWrapper>
            {right.map((menuItem, key) => {
              return <Link key={key} to={menuItem.url} target={menuItem.blank ? "_blank" : ""} >
                <MenuItemWrapper active={actualSite == menuItem.key} scroll={scrollY} key={key} border={menuItem.border}>
                  <MenuItem outlined={menuItem.outlined} >{menuItem.title}</MenuItem>
                </MenuItemWrapper>
              </Link>
            })}
          </ContentWrapper>

        </MenuWrapper>
      </Content>
    </Wrapper>
  )
})

export default Header
